import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useReports} from "../../../api/moderation";

const Item = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;
const Reporter = styled.span`
  font-weight: 500;
  font-size: 17px;`;
const Reason = styled.span`
  font-size: 16px;`;
const Scroll = styled.div`
  max-height: 300px;
  overflow: scroll;
`;

const ViewReportsSheet = styled(({className, post, comment, onClose}) => {

        const {feedbackCh} = useFeedback();
        const type = post ? 'Post' : 'Comment';
        const id = post ? post.id : comment.id;
        const reports = useReports(feedbackCh, id, type.toLowerCase());

        return (
            <div className={className}>

                <Header>
                    <Title>Reports</Title>
                </Header>

                <Scroll>
                    {reports?.map((report) => (
                        <Item key={report.id}>
                            <Reporter>
                                {report.author}
                            </Reporter>
                            {` `}
                            <Reason>
                                {`${report.reason}`}
                            </Reason>
                        </Item>
                    ))}
                </Scroll>

                <Button variant={"grey"} style={{width: '100%', marginTop: '24px'}} onClick={onClose}>Back</Button>

            </div>
        );
    }
)`
`;

export default ViewReportsSheet;
